import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  fr: {
    // Brand
    brand_tagline: "Votre nouveau départ commence ici",
    
    // Navigation
    nav_home: "Accueil",
    nav_search: "Rechercher",
    nav_cities: "Villes",
    nav_blog: "Actualités",
    nav_post_ad: "Déposer une annonce",
    nav_login: "Se connecter",
    nav_register: "S'inscrire",
    nav_my_ads: "Mes annonces",
    nav_favorites: "Favoris",
    nav_profile: "Profil",
    nav_logout: "Déconnexion",
    nav_price_map: "Carte des prix",
    
    // Hero
    hero_title: "Vous avez les clés !",
    hero_subtitle: "Trouvez votre futur logement parmi des milliers d'annonces vérifiées en Algérie",
    hero_search_placeholder: "Ville, quartier, adresse...",
    
    // Search tabs
    search_buy: "Acheter",
    search_rent: "Louer",
    search_estimate: "Estimer",
    search_city: "Où ?",
    search_type: "Type de bien",
    search_price: "Budget",
    search_surface: "Surface",
    search_rooms: "Pièces",
    search_bedrooms: "Chambres",
    search_btn: "Rechercher",
    search_filters: "Plus de critères",
    search_results: "annonces",
    search_sort: "Trier par",
    search_newest: "Plus récentes",
    search_price_asc: "Prix croissant",
    search_price_desc: "Prix décroissant",
    search_surface_desc: "Surface décroissante",
    
    // Property types
    type_all: "Tous types",
    type_apartment: "Appartement",
    type_house: "Maison",
    type_villa: "Villa",
    type_land: "Terrain",
    type_commercial: "Local commercial",
    type_office: "Bureau",
    
    // Property details
    prop_rooms: "pièces",
    prop_bedrooms: "ch.",
    prop_bathrooms: "SDB",
    prop_surface: "m²",
    prop_floor: "Étage",
    prop_parking: "Parking",
    prop_elevator: "Ascenseur",
    prop_balcony: "Balcon",
    prop_garden: "Jardin",
    prop_year: "Année",
    prop_views: "vues",
    prop_contact: "Contacter l'annonceur",
    prop_favorite: "Sauvegarder",
    prop_share: "Partager",
    prop_price_sqm: "DA/m²",
    prop_description: "Description",
    prop_features: "Caractéristiques",
    prop_location: "Localisation",
    prop_similar: "Annonces similaires",
    
    // Guides
    guide_buyer: "Guide de l'acheteur",
    guide_buyer_desc: "Trouvez le bien idéal et réussissez votre achat",
    guide_renter: "Guide du locataire",
    guide_renter_desc: "Tous les conseils pour bien louer",
    guide_seller: "Guide du vendeur",
    guide_seller_desc: "Vendez au meilleur prix",
    
    // Cities
    cities_title: "L'immobilier dans les grandes villes",
    cities_subtitle: "Découvrez les prix et les quartiers",
    cities_listings: "annonces",
    cities_avg_price: "Prix moyen",
    cities_neighborhoods: "Quartiers",
    cities_guide: "Voir les prix",
    cities_all_ads: "Toutes les annonces",
    
    // Blog
    blog_title: "Actualités & Conseils",
    blog_subtitle: "Restez informé du marché immobilier algérien",
    blog_read_more: "Lire l'article",
    blog_all: "Tous les articles",
    blog_category_guide: "Guide",
    blog_category_news: "Actualité",
    blog_category_advice: "Conseil",
    blog_category_neighborhood: "Quartier",
    
    // Auth
    auth_login: "Connexion",
    auth_register: "Inscription",
    auth_email: "Email",
    auth_password: "Mot de passe",
    auth_confirm_password: "Confirmer",
    auth_fullname: "Nom complet",
    auth_phone: "Téléphone",
    auth_user_type: "Vous êtes",
    auth_particulier: "Un particulier",
    auth_agence: "Une agence",
    auth_forgot_password: "Mot de passe oublié ?",
    auth_no_account: "Pas encore inscrit ?",
    auth_has_account: "Déjà un compte ?",
    auth_create_account: "Créer un compte",
    
    // Add property
    add_title: "Déposer une annonce",
    add_free: "100% Gratuit",
    add_step1: "Type de bien",
    add_step2: "Détails",
    add_step3: "Localisation",
    add_step4: "Photos",
    add_property_title: "Titre de l'annonce",
    add_description: "Description",
    add_price: "Prix",
    add_submit: "Publier mon annonce",
    
    // Footer
    footer_about: "À propos de Beytam",
    footer_about_text: "Beytam est le premier site immobilier de confiance en Algérie, dédié aux Algériens locaux et de la diaspora.",
    footer_links: "Liens utiles",
    footer_contact: "Contact",
    footer_follow: "Suivez-nous",
    footer_rights: "Tous droits réservés",
    footer_services: "Nos services",
    
    // CTA
    cta_publish: "Déposer une annonce",
    cta_publish_subtitle: "Vendez vous-même votre bien sur Beytam",
    
    // Common
    common_da: "DA",
    common_da_month: "DA/mois",
    common_see_all: "Tout voir",
    common_back: "Retour",
    common_next: "Suivant",
    common_previous: "Précédent",
    common_save: "Enregistrer",
    common_cancel: "Annuler",
    common_delete: "Supprimer",
    common_edit: "Modifier",
    common_loading: "Chargement...",
    common_no_results: "Aucun résultat trouvé",
    common_error: "Une erreur est survenue",
    common_success: "Opération réussie",
  },
  ar: {
    // Brand
    brand_tagline: "بدايتك الجديدة تبدأ هنا",
    
    // Navigation
    nav_home: "الرئيسية",
    nav_search: "بحث",
    nav_cities: "المدن",
    nav_blog: "الأخبار",
    nav_post_ad: "نشر إعلان",
    nav_login: "تسجيل الدخول",
    nav_register: "إنشاء حساب",
    nav_my_ads: "إعلاناتي",
    nav_favorites: "المفضلة",
    nav_profile: "الملف الشخصي",
    nav_logout: "تسجيل الخروج",
    nav_price_map: "خريطة الأسعار",
    
    // Hero
    hero_title: "مفاتيحك بين يديك!",
    hero_subtitle: "اعثر على سكنك المستقبلي من بين آلاف الإعلانات الموثوقة في الجزائر",
    hero_search_placeholder: "مدينة، حي، عنوان...",
    
    // Search tabs
    search_buy: "شراء",
    search_rent: "إيجار",
    search_estimate: "تقييم",
    search_city: "أين؟",
    search_type: "نوع العقار",
    search_price: "الميزانية",
    search_surface: "المساحة",
    search_rooms: "الغرف",
    search_bedrooms: "غرف النوم",
    search_btn: "بحث",
    search_filters: "المزيد من المعايير",
    search_results: "إعلان",
    search_sort: "ترتيب حسب",
    search_newest: "الأحدث",
    search_price_asc: "السعر تصاعدي",
    search_price_desc: "السعر تنازلي",
    search_surface_desc: "المساحة تنازلية",
    
    // Property types
    type_all: "جميع الأنواع",
    type_apartment: "شقة",
    type_house: "منزل",
    type_villa: "فيلا",
    type_land: "أرض",
    type_commercial: "محل تجاري",
    type_office: "مكتب",
    
    // Property details
    prop_rooms: "غرف",
    prop_bedrooms: "غ.ن",
    prop_bathrooms: "حمام",
    prop_surface: "م²",
    prop_floor: "الطابق",
    prop_parking: "موقف سيارات",
    prop_elevator: "مصعد",
    prop_balcony: "شرفة",
    prop_garden: "حديقة",
    prop_year: "السنة",
    prop_views: "مشاهدة",
    prop_contact: "اتصل بالمعلن",
    prop_favorite: "حفظ",
    prop_share: "مشاركة",
    prop_price_sqm: "دج/م²",
    prop_description: "الوصف",
    prop_features: "المميزات",
    prop_location: "الموقع",
    prop_similar: "إعلانات مشابهة",
    
    // Guides
    guide_buyer: "دليل المشتري",
    guide_buyer_desc: "اعثر على العقار المثالي ونجح في شرائك",
    guide_renter: "دليل المستأجر",
    guide_renter_desc: "جميع النصائح للإيجار الجيد",
    guide_seller: "دليل البائع",
    guide_seller_desc: "بع بأفضل سعر",
    
    // Cities
    cities_title: "العقارات في المدن الكبرى",
    cities_subtitle: "اكتشف الأسعار والأحياء",
    cities_listings: "إعلان",
    cities_avg_price: "متوسط السعر",
    cities_neighborhoods: "الأحياء",
    cities_guide: "عرض الأسعار",
    cities_all_ads: "جميع الإعلانات",
    
    // Blog
    blog_title: "الأخبار والنصائح",
    blog_subtitle: "ابق على اطلاع بسوق العقارات الجزائري",
    blog_read_more: "اقرأ المقال",
    blog_all: "جميع المقالات",
    blog_category_guide: "دليل",
    blog_category_news: "خبر",
    blog_category_advice: "نصيحة",
    blog_category_neighborhood: "حي",
    
    // Auth
    auth_login: "تسجيل الدخول",
    auth_register: "إنشاء حساب",
    auth_email: "البريد الإلكتروني",
    auth_password: "كلمة المرور",
    auth_confirm_password: "تأكيد",
    auth_fullname: "الاسم الكامل",
    auth_phone: "الهاتف",
    auth_user_type: "أنت",
    auth_particulier: "فرد",
    auth_agence: "وكالة",
    auth_forgot_password: "نسيت كلمة المرور؟",
    auth_no_account: "لم تسجل بعد؟",
    auth_has_account: "لديك حساب؟",
    auth_create_account: "إنشاء حساب",
    
    // Add property
    add_title: "نشر إعلان",
    add_free: "مجاني 100%",
    add_step1: "نوع العقار",
    add_step2: "التفاصيل",
    add_step3: "الموقع",
    add_step4: "الصور",
    add_property_title: "عنوان الإعلان",
    add_description: "الوصف",
    add_price: "السعر",
    add_submit: "نشر إعلاني",
    
    // Footer
    footer_about: "عن بيتم",
    footer_about_text: "بيتم هو أول موقع عقاري موثوق في الجزائر، مخصص للجزائريين المحليين والمغتربين.",
    footer_links: "روابط مفيدة",
    footer_contact: "اتصل بنا",
    footer_follow: "تابعونا",
    footer_rights: "جميع الحقوق محفوظة",
    footer_services: "خدماتنا",
    
    // CTA
    cta_publish: "نشر إعلان",
    cta_publish_subtitle: "بع عقارك بنفسك على بيتم",
    
    // Common
    common_da: "دج",
    common_da_month: "دج/شهر",
    common_see_all: "عرض الكل",
    common_back: "رجوع",
    common_next: "التالي",
    common_previous: "السابق",
    common_save: "حفظ",
    common_cancel: "إلغاء",
    common_delete: "حذف",
    common_edit: "تعديل",
    common_loading: "جاري التحميل...",
    common_no_results: "لا توجد نتائج",
    common_error: "حدث خطأ",
    common_success: "تمت العملية بنجاح",
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('beytam_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('beytam_language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'ar' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
